<script>
  import { onMount } from "svelte";
  export let lat;
  export let lon;

  let temperature = undefined;
  let dayNight = undefined;
  let weatherCode = undefined;
  let weatherIcon = undefined;
  let showWeather = false;

  const request = async () => {

    const res = await fetch(
      `https://api.open-meteo.com/v1/forecast?latitude=` + lat + `&longitude=` + lon + `&current_weather=true`
    );
    const resJson = await res.json();

    temperature = resJson.current_weather.temperature;

    dayNight = resJson.current_weather.is_day == 1 ? 'd' : 'n';
        
    weatherCode = resJson.current_weather.weathercode;
    if (weatherCode == 0) {
      weatherIcon = 'https://storage.googleapis.com/icons-weather/w_ic_' + dayNight + '_01anim.svg'
    }
    else if (weatherCode == 1 || weatherCode == 2 || weatherCode == 3) {
      weatherIcon = 'https://storage.googleapis.com/icons-weather/w_ic_' + dayNight + '_02anim.svg'
    }
    else if (weatherCode == 45 || weatherCode == 48) {
      weatherIcon = 'https://storage.googleapis.com/icons-weather/w_ic_' + dayNight + '_05anim.svg'
    }
    else if (weatherCode == 51 || weatherCode == 53 || weatherCode == 55) {
      weatherIcon = 'https://storage.googleapis.com/icons-weather/w_ic_' + dayNight + '_10anim.svg'
    }
    else if (weatherCode == 56 || weatherCode == 57) {
      weatherIcon = 'https://storage.googleapis.com/icons-weather/w_ic_' + dayNight + '_21anim.svg'
    }
    else if (weatherCode == 61 || weatherCode == 63 || weatherCode == 65) {
      weatherIcon = 'https://storage.googleapis.com/icons-weather/w_ic_' + dayNight + '_11anim.svg'
    }
    else if (weatherCode == 66 || weatherCode == 67) {
      weatherIcon = 'https://storage.googleapis.com/icons-weather/w_ic_' + dayNight + '_29anim.svg'
    }
    else if (weatherCode == 71 || weatherCode == 73 || weatherCode == 75) {
      weatherIcon = 'https://storage.googleapis.com/icons-weather/w_ic_' + dayNight + '_18anim.svg'
    }
    else if (weatherCode == 77) {
      weatherIcon = 'https://storage.googleapis.com/icons-weather/w_ic_' + dayNight + '_18anim.svg'
    }
    else if (weatherCode == 80 || weatherCode == 81 || weatherCode == 82) {
      weatherIcon = 'https://storage.googleapis.com/icons-weather/w_ic_' + dayNight + '_14anim.svg'
    }
    else if (weatherCode == 85 || weatherCode == 86) {
      weatherIcon = 'https://storage.googleapis.com/icons-weather/w_ic_' + dayNight + '_14anim.svg'
    }
    else if (weatherCode == 95) {
      weatherIcon = 'https://storage.googleapis.com/icons-weather/w_ic_' + dayNight + '_19anim.svg'
    }
    else if (weatherCode == 96 || weatherCode == 99) {
      weatherIcon = 'https://storage.googleapis.com/icons-weather/w_ic_' + dayNight + '_19anim.svg'
    }

    showWeather = true;
  };

  onMount(() => {
    request(); // first request
    const interval = setInterval(request, 1800000); // request every 30 minutes

    return () => {
      clearInterval(interval);
    };
  });
</script>

{#if showWeather}
  <span>
    {temperature}º <img class="logo-weather inline-block" alt="Logo Tempo" src="{weatherIcon}" />
  </span>
{:else}
  <span></span>
{/if}
